<template>
  <div class="sidebar bg-magnolia round-10 br-one">
    <div class="sidebar-widget">
      <h3 class="fs-20 mb-15">Information</h3>
      <div class="portfolio-brief list-style">
        <li>
          <span class="d-inline-block">Customer:</span>
          <span class="text-title">William Smith</span>
        </li>
        <li>
          <span class="d-inline-block">Start Date:</span>
          <span class="text-title">12 January, 2023</span>
        </li>
        <li>
          <span class="d-inline-block">End Date:</span>
          <span class="text-title">18 January, 2023</span>
        </li>
        <li>
          <span class="d-inline-block">Category:</span>
          <span class="text-title">Business</span>
        </li>
        <li>
          <span class="d-inline-block">Email:</span>
          <span class="text-title">hello@mazii.app</span>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarWidget",
};
</script>